import { BaseEntity } from "./base-entity";

export enum MatterInvoiceStatus {
  complete = 'COMPLETE',
  pending = 'PENDING',
  cancelled = 'CANCELLED',
  error = 'ERROR',
  failed = 'FAILED',
  mandate_active = 'MANDATE_ACTIVE',
  mandate_submitted = 'MANDATE_SUBMITTED'
}

export class MatterInvoice extends BaseEntity {
  id: number;
  matterId: number;
  invoiceAmount: number;
  status: MatterInvoiceStatus;
  createdDate: Date;
  dueDate?: Date;
  recipient?: string;
  paymentId: number;
  paymentUrl: string;
  documentId: number;
  packageGuid: string;
}
